export default {
    login_page_title: 'Página de inicio de sesión en la nube',
    login_page_language: 'Lenguaje',
    login_page_english: 'Inglés',
    login_page_spanish: 'Español',
    login_page_templates: 'Plantillas',
    login_page_save: 'Guardar página de inicio de sesión',
    login_page_preview: 'Vista previa',
    login_page_placeholder: 'Escriba aquí el contenido de la página',
    login_page_create_message: 'Contenido guardado',
    login_page_preview_message: 'Vista previa guardada',
    login_page_select: 'Seleccionar',
    login_page_insert_image: 'Insertar imagen',
    login_page_create_edit_template: 'Crear/editar plantilla',
}